import { Injectable, Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { Router } from '@angular/router';
import { IMfeService } from '@mynexus/mfe-core';

const map = {
  // add lazy-loaded components here
  'mnc-reporting-member-care-history-report': () => import('../../features/member-care-history-report/member-care-history-report.component'),
}

@Injectable({
  providedIn: 'root'
})
export class ReportingMfeService implements IMfeService {
  donePromise: Promise<boolean>;
  resolve: (value: boolean) => void;

  constructor(
    private router: Router,
    private injector: Injector
  ) {
    this.donePromise = new Promise<boolean>((resolve) => {
      this.resolve = resolve;
    });
   }

  navigate(path: string): void {
    this.router.navigate([path]);
  }

  loadComponent(name: string): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        if(map[name]){
          map[name]().then(module => {
            customElements.define(
              name,
              createCustomElement<any>(module[Object.keys(module)[0]], { injector: this.injector })
            );
            resolve(true);
          });
        }else {
          reject('component not found');
        }
      }
      catch (error) {
        reject(error);
      }
    });
  }
}
